module.exports = new __parcel__URL__("MMIRL1.2259f878.jpg").toString();